import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScriptLoaderService {

  private loaded: { [key: string]: boolean } = {};

  loadOnce(src: string, id: string, callback?: () => void) {
    if (this.loaded[id]) {
      // Already loaded → just callback
      callback && callback();
      return;
    }

    const existing = document.getElementById(id);
    if (existing) {
      this.loaded[id] = true;
      callback && callback();
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.id = id;
    script.type = 'text/javascript';
    script.onload = () => {
      this.loaded[id] = true;
      callback && callback();
    };

    document.body.appendChild(script);
  }
}
